import { useCallback, useEffect, useRef, useState } from 'react';
import './App.css';
import Dropdown from 'react-bootstrap/Dropdown';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import MainNavigation from './components/MainNavigation';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Accordion from 'react-bootstrap/Accordion';
import Placeholder from 'react-bootstrap/Placeholder';
import ProgressBar from 'react-bootstrap/ProgressBar';
import maplibregl, { IControl, prewarm } from 'maplibre-gl';
import { ThemeContext } from './components/Context';
import { decode } from "@googlemaps/polyline-codec";
import ToggleButton from 'react-bootstrap/ToggleButton';
import ListGroup from 'react-bootstrap/ListGroup';
import Modal from 'react-bootstrap/Modal';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import { useWakeLock } from 'react-screen-wake-lock';
import axios from 'axios';
import log from './Utilities/log';
import { store, getStoredOrDefault } from './Utilities/storageUtils';
import turfDistance from "@turf/distance";
import MBTALogo from '/MBTA.svg';
import 'maplibre-gl/dist/maplibre-gl.css';
import { arrow_right_circle, bus_front, sign_turn_right, train_freight_front, train_lightrail_front } from './components/Icons';
import { useTour } from '@reactour/tour'
import { getConfig, getURL } from './Utilities/MBTARequest';
const MBTALogoAlt = 'MBTA T Logo';

prewarm();

function decodePolyLine(value: string): Array<Array<number>> {
  let arrCoordinates = decode(value)
  return arrCoordinates.map((numbers) => { return [numbers[1], numbers[0]] });
}

function clearOldData(currentDataName: string, oldDataStartWith: string) {
  const deleteElements = []
  for (let i = 0; i < localStorage.length; i++) {
    const currentKey = localStorage.key(i);
    if (currentKey?.toLowerCase().startsWith(oldDataStartWith.toLowerCase()) && currentKey.toLowerCase().trim() != currentDataName.toLowerCase().trim()) {
      deleteElements.push(currentKey);
    }
  }

  for (let i = 0; i < deleteElements.length; i++) {
    localStorage.removeItem(deleteElements[i]);
  }
}

function App() {
  const { isSupported, released, request, release } = useWakeLock({});
  const { setIsOpen, currentStep, setCurrentStep } = useTour()

  const lastLat = "lastLat";
  const lastLng = "lastLng";
  const lastZoom = "lastZoom"
  const lastTheme = "lastTheme";
  const todayRoutes = `todayRoutes_${__BUILD_DATE__}_${new Date().toDateString()}`
  const todayStops = `todayStops_${__BUILD_DATE__}_${new Date().toDateString()}`
  const lastTransportMode = 'lastTransportMode';
  const lastStopSort = 'lastStopSort';

  clearOldData(todayRoutes, "todayroutes");
  clearOldData(todayStops, "todaystops");

  const storedRoutes = getStoredOrDefault(todayRoutes, new Array());
  const storedRoutesMap = new Map<string, any>();
  for (let i = 0; i < storedRoutes.length; i++) {
    storedRoutesMap.set(storedRoutes[i][0], storedRoutes[i][1]);
  }
  const [routes, setRoutes] = useState({ routes: storedRoutesMap });
  const setRoutesMutate = (routes: Map<string, any>) => {
    setRoutes({ routes: routes })
    store(todayRoutes, Array.from(routes));
  }

  const storedStops = getStoredOrDefault(todayStops, new Array());
  const storedStopsMap = new Map<string, any>();
  for (let i = 0; i < storedStops.length; i++) {
    storedStops[i][1].showStop = false;
    storedStopsMap.set(storedStops[i][0], storedStops[i][1]);
  }
  const [stops, setStops] = useState({ stops: storedStopsMap });
  const setStopsMutate = (stops: Map<string, any>) => {
    setStops({ stops: stops });
    store(todayStops, Array.from(stops));
  }

  const [mapMarkers, setMapMarkers] = useState({ markers: new Map<string, maplibregl.Marker>() });
  const setMapMarkersMutate = (markers: Map<string, maplibregl.Marker>) => {
    setMapMarkers({ markers: markers })
  }

  let defaultTheme = "light";
  const darkThemeMq = window.matchMedia("(prefers-color-scheme: dark)");
  if (darkThemeMq.matches) {
    defaultTheme = "dark";
  }

  const [theme, setTheme] = useState(getStoredOrDefault(lastTheme, defaultTheme));

  const mapStyles = new Map([["light", "arcgis/navigation"], ["dark", "arcgis/navigation-night"]]);
  const [currentMapStyle, setCurrentMapStyle] = useState(getStoredOrDefault("mapStyle", theme));
  const gatedStyleSetter = useCallback((value: string) => {
    setCurrentMapStyle(value);
    store("mapStyle", value);
  }, []);


  const defaultLat = getStoredOrDefault(lastLat, 42.3601318);
  const defaultLng = getStoredOrDefault(lastLng, -71.0589683);
  const defaultRadius = 0.01;
  const [lng, setLng] = useState(defaultLng);
  const [lat, setLat] = useState(defaultLat);
  const [userLng, setUserLng] = useState(defaultLng);
  const [userLat, setUserLat] = useState(defaultLat);
  const [transportMode, setTransportMode] = useState(getStoredOrDefault(lastTransportMode, "0,1"))
  const defaultZoom = getStoredOrDefault(lastZoom, 15);
  const [zoom, setZoom] = useState(defaultZoom);
  const [radius, setRadius] = useState(defaultRadius);
  const [predictions, setPredictions] = useState({ predictions: new Array() });
  const [stopIDs, setStopIDs] = useState({ stopIDs: new Set<string>() });
  const [parentStopIDs, setParentStopIDs] = useState({ parentStopIDs: new Set<string>() });
  const [routeIDs, setRouteIDs] = useState({ routeIDs: new Set<string>() });
  const [bootstrapVariant, setBootstrapvariant] = useState("");
  const [dataLoaded, setdataLoaded] = useState(false);
  const [stationFilter, setStationFilter] = useState("");
  const [routeFilter, setRouteFilter] = useState("");

  enum stopSortList {
    Distance = "Distance",
    Time = "Time"
  }
  const [stopListSortBy, setStopListSortBy] = useState(getStoredOrDefault(lastStopSort, stopSortList.Distance));

  const defaultPage = "Map";
  const lastPage = "lastPage";
  const [currentPage, setCurrentPage] = useState(getStoredOrDefault(lastPage, defaultPage));
  const setPageAndStore = (value: string) => {
    setCurrentPage(value);
    store(lastPage, value);
  }

  const mapContainer = useRef<any>(null);
  const map = useRef<any>(null);
  const geoControl = useRef(new maplibregl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true
    },
    showAccuracyCircle: false
  }));

  const getPredictions = async () => {
    log('getting prediction')
    axios.get(getURL("predictions",
      `page[limit]=200&sort=time&fields[prediction]=arrival_time,departure_time,direction_id&filter[route_type]=${transportMode}&filter[latitude]=${userLat}&filter[longitude]=${userLng}&filter[radius]=${radius}`),
      getConfig()).then((response) => {
        log("received predictions");
        const responseData = response.data.data;
        const routeSet = routeIDs.routeIDs;
        const stopSet = stopIDs.stopIDs;
        const predictionData = [];
        for (let i = 0; i < responseData.length; i++) {
          if ((responseData[i].attributes.arrival_time) ||
            (responseData[i].attributes.departure_time)) {
            routeSet.add(responseData[i].relationships.route.data.id);
            stopSet.add(responseData[i].relationships.stop.data.id);
            const arrivalTime = new Date(responseData[i].attributes.arrival_time);
            const departureTime = new Date(responseData[i].attributes.departure_time);
            predictionData.push({
              id: responseData[i].id,
              arrival_time: arrivalTime,
              departure_time: departureTime,
              route_id: responseData[i].relationships?.route?.data?.id,
              stop_id: responseData[i].relationships?.stop?.data?.id,
              direction_id: responseData[i].attributes.direction_id,
              updated: new Date()
            })
          }
        }
        setRouteIDs({ routeIDs: routeSet });
        setStopIDs({ stopIDs: stopSet });
        setPredictions({ predictions: predictionData });
        setdataLoaded(true);
      }, (error) => {
        log("predictions errored");
        log(error);
        //do nothing
      });
  }

  const MBTARoutePrefix = "MBTARoute-"

  const addPolylines = () => {
    log("add polylines");
    const currentLayers = map.current.getStyle().layers;
    const layerMap = new Map<string, any>();

    for (let i = 0; i < currentLayers.length; i++) {
      layerMap.set(currentLayers[i].id, currentLayers[i]);
    }
    routes.routes.forEach((value, key) => {
      let polyLines: number[][] = [];
      const layerID = `${MBTARoutePrefix}${key}`;
      if (transportMode.split(',').includes(value.type) && !layerMap.has(layerID)) {
        log("adding layer")
        for (let i = 0; i < value.polylines.length; i++) {
          polyLines = polyLines.concat(decodePolyLine(value.polylines[i]));
        }
        map.current.addSource(layerID, {
          'type': 'geojson',
          'data': {
            'type': 'Feature',
            'properties': {},
            'geometry': {
              'type': 'LineString',
              'coordinates': polyLines
            },
          }
        });
        map.current.addLayer({
          'id': layerID,
          'type': 'line',
          'source': layerID,
          'layout': {
            'line-join': 'round',
            'line-cap': 'round'
          },
          'paint': {
            'line-color': '#' + value.color,
            'line-width': 3
          },
        });
      } else {
        if (!transportMode.split(',').includes(value.type) && layerMap.has(layerID)) {
          log("removing layer")
          map.current.removeLayer(layerID);
          map.current.removeSource(layerID);
        }
      }
    });
  }

  useEffect(() => {
    log('updating route info');
    const currentRouteIds = routeIDs.routeIDs;
    if (currentRouteIds.size > 0) {
      currentRouteIds.forEach((_, value) => {
        if (routes.routes instanceof Map && routes.routes.has(value)) {
          currentRouteIds.delete(value);
        }
      });

      const routeMap = routes.routes;

      if (currentRouteIds.size > 0) {
        axios.get(`https://us-east-1.aws.data.mongodb-api.com/app/data-ghvnc/endpoint/routes?routes=${Array.from(currentRouteIds).join(',')}&types=${transportMode}`).then(
          (response) => {
            log("received routes");
            response.data.map((item: any) => {
              if (routeMap.get(item['_id'])) {
                item.current_direction = routeMap.get(item['_id']).current_direction;
              } else {
                item.current_direction = 0;
              }
              routeMap.set(item['_id'], item);
            });

            predictions.predictions.forEach((prediction) => {
              if (routeMap.has(prediction.route_id)) {
                const predictionRoute = routeMap.get(prediction.route_id);
                predictionRoute.current_direction = prediction.direction_id
                routeMap.set(prediction.route_id, predictionRoute);
              }
            });

            setRoutesMutate(routeMap);
          },
          (error) => {
            log("routes errored");
            log(error);
          }
        );
      } else {
        setRoutesMutate(routeMap);
      }
    }
  }, [routeIDs, transportMode]);

  const MBTAMarkerPrefix = 'MBTAMarker';

  useEffect(() => {
    mapMarkers.markers.forEach((value) => {
      value._element.children[0].setAttribute("style", `color: ${currentMapStyle == "light" ? "black" : "white"}`);
    });
  }, [currentMapStyle]);

  const addMapMarkers = (removeAll: boolean = false) => {
    const currentMarkers = mapMarkers.markers;
    if (removeAll) {
      currentMarkers.forEach((value, key) => {
        value.remove();
        currentMarkers.delete(key);
      })
    }
    log("adding markers");
    const newMapMarkers = new Map<string, maplibregl.Marker>();
    stops.stops.forEach((value, key) => {
      if (value.parent) {
        return;
      }
      const mapMarkerID = `${MBTAMarkerPrefix}-${value.parent_id == null || value.parent_id == value.id ? key.toString() + '-parent' : value.parent_id}-${value.type}`;

      if (!newMapMarkers.has(mapMarkerID)) {
        if (value.type == transportMode) {
          if (currentMarkers.has(mapMarkerID)) {
            newMapMarkers.set(mapMarkerID, currentMarkers.get(mapMarkerID)!);
          } else {
            log("new marker")
            const existingMarker = document.getElementById(`${mapMarkerID}-marker`)!;
            const el = existingMarker != null ? existingMarker : document.createElement('div');
            el.onclick = () => {
              document.getElementById(`${value.parent_id ? value.parent_id : value.id}-stop-row`)?.click();
            }
            el.id = `${mapMarkerID}-marker`
            el.style.backgroundImage = `url(${MBTALogo})`;
            el.style.backgroundSize = '100%';
            el.style.width = `${20}px`;
            el.style.height = `${20}px`;
            el.id = mapMarkerID;
            const innerText = document.createElement('div');
            innerText.className = "MBTAMarkerText";
            innerText.textContent = value.name;
            innerText.id = `${mapMarkerID}-marker-text-${key}`;
            innerText.setAttribute("style", `color: ${currentMapStyle == "light" ? "black" : "white"}`)
            el.appendChild(innerText);
            const stopMarker = new maplibregl.Marker({ element: el }).setLngLat([value.longitude, value.latitude]).addTo(map.current);
            newMapMarkers.set(mapMarkerID, stopMarker);
          }
        } else {
          if (currentMarkers.has(mapMarkerID)) {
            mapMarkers.markers.get(mapMarkerID)!.remove();
          }
        }
      }
    });

    setMapMarkersMutate(newMapMarkers);
  }

  const addMapElements = () => {
    addPolylines();
    addMapMarkers();
  }

  useEffect(() => {
    log('updating stop info');
    const currentStopIds = stopIDs.stopIDs;
    if (currentStopIds.size > 0) {
      currentStopIds.forEach((_, value) => {
        if (stops.stops instanceof Map && stops.stops.has(value)) {
          currentStopIds.delete(value);
        }
      });

      const stopMap = stops.stops;
      const parentStopIDsSet = parentStopIDs.parentStopIDs;
      if (currentStopIds.size > 0) {
        axios.get(getURL("stops", `fields[stop]=latitude,longitude,name&filter[route_type]=${transportMode}&filter[id]=${Array.from(currentStopIds).join(',')}`), getConfig()).then(
          (response) => {
            log("received stops");
            response.data.data.map((item: any) => {
              const attributes = item['attributes'];
              attributes.type = transportMode;
              attributes.parent = false;
              if (item.relationships.parent_station.data) {
                attributes.parent_id = item.relationships.parent_station.data?.id;
                parentStopIDsSet.add(item.relationships.parent_station.data.id);
              } else {
                attributes.parent_id = null;
              }
              attributes.id = item['id'];
              if (stopMap.has(attributes.id)) {
                attributes.showStop = stopMap.get(attributes.id).showStop;
              } else {
                attributes.showStop = false;
              }
              stopMap.set(item['id'], attributes);
            });
            setStopsMutate(stopMap);
            setParentStopIDs({ parentStopIDs: parentStopIDsSet });
          },
          (error) => {
            log("stops errored");
            log(error);
          }
        );
      } else {
        setStopsMutate(stopMap);
        setParentStopIDs({ parentStopIDs: parentStopIDsSet });
      }
    }
  }, [stopIDs, transportMode]);

  useEffect(() => {
    const currentParentStopIds = parentStopIDs.parentStopIDs;
    if (currentParentStopIds.size > 0) {
      currentParentStopIds.forEach((_, value) => {
        if (stops.stops instanceof Map && stops.stops.has(value)) {
          currentParentStopIds.delete(value);
        }
      });
      const stopMap = stops.stops;
      if (currentParentStopIds.size > 0) {
        axios.get(getURL("stops", `fields[stop]=latitude,longitude,name&filter[id]=${Array.from(currentParentStopIds).join(',')}`), getConfig()).then(
          (response) => {
            log("received parent stops");
            response.data.data.map((item: any) => {
              const attributes = item['attributes'];
              attributes.type = transportMode;
              attributes.parent_id = item['id'];
              attributes.parent = true;
              attributes.id = item['id'];
              stopMap.set(item['id'], attributes);
            });
            setStopsMutate(stopMap);
          },
          (error) => {
            log("stops errored");
            log(error);
          }
        );
      } else {
        setStopsMutate(stopMap);
      }
    }
  }, [parentStopIDs]);

  useEffect(() => {
    store(lastZoom, zoom);
    if (map.current) {
      map.current.setZoom(zoom);
    }
  }, [zoom]);


  useEffect(() => {
    store(lastLat, lat);
    store(lastLng, lng);
    log("setting current location boolean");
    if (currentPage != defaultPage) {
      if (map.current) {
        map.current.remove();
        map.current = null;
        setMapMarkersMutate(new Map<string, any>());
      }
      return;
    }

    if (map.current) {
      log("setting existing map location");
      map.current.setCenter([lng, lat]);
      map.current.setZoom(zoom);
      return;
    } // initialize map only once



    class mapStyleControl implements IControl {
      _map: maplibregl.Map | null = null;
      _container: HTMLElement | null = null;
      _style: string = "light"
      _setStyle: (value: string) => void = (_) => { }
      constructor(style: string, setStyle: (value: string) => void) {
        this._style = style;
        this._setStyle = setStyle;
        return this;
      }

      setStyle(value: string) {
        this._style = value;
        this._map?.setStyle(`https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/${mapStyles.get(this._style)}?token=${import.meta.env.VITE_ARCGIS_API_KEY}`);
        const buttons = this._container?.getElementsByClassName("maplibregl-ctrl-style");
        for (let i = 0; buttons && i < buttons.length; i++) {
          buttons[i].textContent = this.styleName();
        }
        this._setStyle(value);
      }

      styleName() {
        return this._style.charAt(0).toUpperCase() + this._style.slice(1);
      }

      onAdd(map: maplibregl.Map): HTMLElement {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'maplibregl-ctrl maplibregl-ctrl-group';
        const mapStyleButton = document.createElement('button');
        mapStyleButton.className = "btn btn-light maplibregl-ctrl-style";
        mapStyleButton.ariaLabel = "Select Style";
        mapStyleButton.textContent = this.styleName();


        mapStyleButton.onclick = () => {
          this.setStyle(this._style == "light" ? "dark" : "light");
        }
        this._container.appendChild(mapStyleButton);
        return this._container;
      }

      onRemove(_: maplibregl.Map): void {
        this?._container?.parentNode?.removeChild(this._container);
        this._map = null;
      }
    }

    log("initializing new map");
    map.current = new maplibregl.Map({
      container: mapContainer.current,
      style: `https://basemapstyles-api.arcgis.com/arcgis/rest/services/styles/v2/styles/${mapStyles.get(currentMapStyle)}?token=${import.meta.env.VITE_ARCGIS_API_KEY}`,
      center: [lng, lat],
      zoom: zoom,
      attributionControl: false,
    });

    log("adding geolocation control");
    const styleControl = new mapStyleControl(currentMapStyle, gatedStyleSetter);
    map.current.addControl(geoControl.current);
    map.current.addControl(new maplibregl.NavigationControl());
    map.current.addControl(new maplibregl.FullscreenControl({ container: mapContainer.current }));
    map.current.addControl(styleControl);

    interface onGeolocate {
       coords: GeolocationCoordinates | undefined
     }
     geoControl.current.on('geolocate', function (e) {
      if (e) {
        const geolocateCoords = e as onGeolocate;

         map.current.flyTo({
          center: [geolocateCoords.coords?.longitude, geolocateCoords.coords?.latitude],
           zoom: zoom //set zoom 
        });
      }
    });

    map.current.on('moveend', () => {
      updateMapDetails()
    });

    map.current.on('zoomend', () => {
      updateMapDetails()
    });

    map.current.on('load', () => {
      if (navigator.geolocation) {

        navigator.permissions.query({ name: "geolocation" }).then((result) => {
          if (result.state === "granted") {
            // geoControl.current.trigger();
          }
        });
      }
    });

    map.current.on('style.load', () => {
      addMapElements();
    });
  }, [lat, lng, currentPage]);

  function updateMapDetails() {
    setLng(map.current.getCenter().lng);
    setLat(map.current.getCenter().lat);
    setUserLng(map.current.getCenter().lng);
    setUserLat(map.current.getCenter().lat);
    setZoom(map.current.getZoom().toFixed(2));
    const currentBounds = map.current.getBounds()
    setRadius(turfDistance([currentBounds._ne.lat, currentBounds._ne.lng], [currentBounds._sw.lat, currentBounds._sw.lng], { units: 'degrees' }) / 2);
  }

  function directionLink(lat: string, lng: string) {
    return `https://www.google.com/maps/dir/?api=1&travelmode=walking&destination=${lat}%2C${lng}`
  }

  useEffect(() => {
    getPredictions();
  }, []);

  useEffect(() => {
    if (dataLoaded && !getStoredOrDefault("reactour", false)) {
      setTimeout(() => {
        setIsOpen(true);
        store("reactour", true);
      }, 2000)
    }
  }, [dataLoaded])

  useEffect(() => {
    if (isSupported) {
      request();
    }
    return () => {
      if (!released)
        release();
    }
  }, [])

  useEffect(() => {
    getPredictions();
    const timer = setInterval(() => getPredictions(), 10000);
    return () => clearInterval(timer);
  }, [lat, lng, transportMode]);

  useEffect(() => {
    log("useEffect routes");
    if (routes.routes instanceof Map && map.current && map.current.isStyleLoaded()) {
      addPolylines();
    }
  }, [lat, lng, radius, routes, transportMode])

  useEffect(() => {
    log("useEffect stops");
    if (stops.stops instanceof Map && map.current) {
      addMapMarkers();
    }
  }, [lat, lng, radius, stops, transportMode]);

  useEffect(() => {
    log("updating theme");
    document.documentElement.setAttribute("data-bs-theme", theme)
    store(lastTheme, theme);
    setBootstrapvariant(theme == "light" ? "dark" : "light");
  }, [theme]);

  const updateTransport = (transportMode: string) => {
    setTransportMode(transportMode);
    store(lastTransportMode, transportMode);
  }
  const getDuration = (arrival: Date, departure: Date): number => {
    const value = arrival > new Date() ? arrival : departure;
    return Math.max((value.getTime() - new Date().getTime()), 0) / 1000;
  }

  const getRemainingString = (value: number): string => {
    if (value == 0) {
      return '0';
    }

    const minutes = Math.floor(value / 60);
    const hours = Math.floor(minutes / 60);
    const seconds = value % 60;
    if (hours > 0) {
      return `${hours} h`
    }
    else if (minutes > 5) {
      return `${minutes} m`
    } else if (minutes > 0) {
      return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    } else {
      return `${seconds} s`;
    }
  }
  const distanceTwoPoints = (lat1: number, lat2: number, lng1: number, lng2: number): { distance: number, distanceString: string } => {
    let distance = turfDistance([lat1, lng1], [lat2, lng2], { units: "feet" });
    let distanceString = '';
    if (distance > 500) {
      const distanceForString = distance * 0.0001894;
      distanceString = `${distanceForString.toFixed(2)} mi`;
    } else {
      distanceString = `${distance.toFixed(0)} ft`; ''
    }
    return { distance: distance, distanceString: distanceString }
  }

  function showStop(stopId: string, showStop: boolean) {
    const currentStops = stops.stops;
    if (currentStops.has(stopId)) {
      currentStops.get(stopId).showStop = showStop;
      setStopsMutate(currentStops);
    }
  }
  function getStopList(currentStops: Array<any>, predictions: Array<any>) {
    predictions = predictions.map((prediction) => {
      prediction.duration = getDuration(prediction.arrival_time, prediction.departure_time);
      return prediction;
    }).filter((prediction) => {
      return prediction.duration > 0;
    }).sort((a, b) => {
      return a.duration - b.duration;
    });

    const displayStops = currentStops.filter((value) => {
      return value.id == value.parent_id || value.parent_id == null || value.showStop == true;
    }).map((value) => {
      const distanceObject = distanceTwoPoints(lat, value.latitude, lng, value.longitude);
      value.distance = distanceObject.distance;
      value.distanceString = distanceObject.distanceString;
      value.predictions = predictions.filter((prediction) => {
        return (stops.stops.get(prediction.stop_id)?.parent_id == value.id || prediction.stop_id == value.id)
          && (prediction.arrival_time > new Date() || prediction.departure_time > new Date());
      });
      return value;
    }).filter((value) => {
      return value.predictions && value.predictions.length > 0;
    }).sort((a, b) => {
      if (stopListSortBy == stopSortList.Distance)
        return a.distance - b.distance

      return a.predictions[0].duration - b.predictions[0].duration;
    });

    return displayStops.map((displayStop, displayStopIndex) => {
      const currentPredictions = displayStop.predictions;

      if (currentPredictions.length == 0) {
        return;
      }

      const stopMostRecentPredictions = new Map<string, Array<any>>();
      currentPredictions.forEach((value: any) => {
        if (value.arrival_time > new Date() && routes.routes.has(value.route_id)) {
          const currentColor = routes.routes.get(value.route_id).color;
          let stack = [];
          if (stopMostRecentPredictions.has(currentColor)) {
            stack = stopMostRecentPredictions.get(currentColor)!;
          }
          stack.push(value);
          stopMostRecentPredictions.set(currentColor, stack);
        }
      })

      if(stationFilter != "" && displayStop.name.toLowerCase().indexOf(stationFilter.toLowerCase()) < 0 ){
        return;
      }

      return <>
        <ListGroup.Item key={`${displayStopIndex}-list-item`} className={'stop-row'} id={`${displayStop.id}-stop-row`} onClick={() => {
          showStop(displayStop.id, true);
          if (currentStep == 4)
            setCurrentStep(currentStep + 1);
        }} >
          <Row>
            <Col xs={6} as={'h6'} className='p-1 d-flex flex-wrap'>
              {displayStop.name}&nbsp;<div className='text-body-secondary fw-light'>({displayStop.distanceString})</div>
            </Col>
            <Col className={`d-flex justify-content-center border-start`} xs={6} >
              {
                [...stopMostRecentPredictions].map((prediction, predictionIndex) => {
                  const currentMostRecentPrediction = prediction[1].shift();
                  if (currentMostRecentPrediction.duration == 0) {
                    return <div className='timer-wrapper-list' ></div>;
                  }

                  return <div className='timer-wrapper-list'
                    key={`${prediction[0]}-${predictionIndex}-${new Date()}`} >
                    <CountdownCircleTimer
                      isPlaying
                      duration={currentMostRecentPrediction.duration}
                      colors={`#${prediction[0]}`}
                      size={50}
                      strokeWidth={4}
                      onComplete={() => {
                        // return {newInitialRemainingTime: currentMostRecentPrediction.duration}
                      }}
                    >
                      {({ remainingTime }) => {
                        return <div role="timer" aria-live="assertive" className='timer-string d-flex justify-content-center'>
                          <div className='timer-content'>{getRemainingString(remainingTime)}</div>
                        </div>
                      }}
                    </CountdownCircleTimer>
                  </div>
                })
              }
            </Col>
          </Row>
        </ListGroup.Item>
        <Modal key={`${displayStopIndex}-modal`} show={displayStop.showStop} fullscreen onHide={() => {
          showStop(displayStop.id, false)
        }}>
          <Modal.Header closeButton id='schedule-list-close'>
            <Modal.Title className='d-flex align-items-center' as={'h1'}>
              <img src={MBTALogo} width={50} height={50} alt={MBTALogoAlt}></img>&nbsp;{displayStop.name}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ListGroup>
              {
                currentPredictions.map((value: any) => {
                  const currentDuration = getDuration(value.arrival_time, value.departure_time);
                  if (currentDuration == 0) {
                    return;
                  }

                  const leaving = value.arrival_time < value.departure_time && value.departure_time > new Date() && value.arrival_time < new Date();
                  const currentStop = stops.stops.get(value.stop_id);
                  const currentRoute = routes.routes.get(value.route_id);
                  const rowKey = `${value.id}-predictionrow-${leaving ? "leaving" : "arriving"}`;
                  const timerKey = `${rowKey}-timer`;

                  return (
                    <Row key={rowKey} id={rowKey}>
                      <Col className='border' xs={9}>
                        <Card className='border-0'>
                          <Card.Body>
                            <Card.Title>
                              {arrow_right_circle(24, 24)}
                              &nbsp;{`${transportMode == '3' && currentRoute?.short_name != "" ? `${currentRoute?.short_name} -` : ""}  ${currentRoute?.directions[value.direction_id]}`}
                            </Card.Title>
                            <Card.Text className='text-body-secondary d-flex align-items-center justify-content-between'>
                              {currentRoute?.long_name}<Placeholder xs={1} style={{
                                "backgroundColor": `#${routes.routes.get(value.route_id)?.color}`,
                                'width': "30px", "height": "30px", 'borderRadius': "20px", "opacity": "1"
                              }} align="end" />
                            </Card.Text>
                            {currentStop && <Card.Text className='text-body-secondary x-small d-flex align-items-center'>
                              <Card.Link className='direction-link' target='_' href={directionLink(currentStop.latitude, currentStop.longitude)}>
                                {sign_turn_right(20, 20)}&nbsp;<span className='fs-6'>Get Directions</span>&nbsp;
                              </Card.Link>
                              <span> ({distanceTwoPoints(lat, currentStop.latitude, lng, currentStop.longitude).distanceString})</span>
                            </Card.Text>}
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col className={`border d-flex justify-content-center align-items-center`} xs={3}>
                        <div className='timer-wrapper' key={timerKey} id={timerKey}>
                          <CountdownCircleTimer
                            isPlaying
                            duration={currentDuration}
                            key={`${value.id}`}
                            colors={['#004777', '#F7B801', '#A30000', '#A30000']}
                            colorsTime={[30, 15, 10, 0]}
                            size={50}
                            strokeWidth={4}
                          >
                            {({ remainingTime }) => {
                              return <div role="timer" aria-live="assertive">
                                {getRemainingString(remainingTime)}
                              </div>
                            }}
                          </CountdownCircleTimer>
                          {leaving && <div>
                            Departing
                          </div>}
                          {!leaving && <div>
                            Arriving
                          </div>}
                        </div>
                      </Col>
                    </Row>)
                })
              }
            </ListGroup>
          </Modal.Body>
        </Modal>
      </>;
    }
    )
  }

  return (
    <ThemeContext.Provider value={{ theme: theme, switchTheme: setTheme }}>
      <>
        <MainNavigation currentPage={currentPage} setCurrentPage={setPageAndStore}></MainNavigation>
        <Container className='pt-1 site-container'>
          <Row className='py-1'>
            <ToggleButtonGroup size='sm' className='d-flex flex-row justify-content-between' name="transportMode" id="transportMode" type="radio" defaultValue={transportMode} onChange={(e) => { updateTransport(e) }}>
              <ToggleButton id="tbg-btn-1" value={'0,1'} variant={bootstrapVariant}>
                {train_lightrail_front()} Subway
              </ToggleButton>
              <ToggleButton id="tbg-btn-2" value={'2'} variant={bootstrapVariant}>
                {train_freight_front()} Rail
              </ToggleButton>
              <ToggleButton id="tbg-btn-3" value={'3'} variant={bootstrapVariant}>
                {bus_front()} Bus
              </ToggleButton>
            </ToggleButtonGroup>
          </Row>
          {currentPage == "Map" &&
            <>
              <Row>
                <div ref={mapContainer} className="map-container" />
              </Row>
              {dataLoaded && predictions.predictions.length == 0 && (
                <Row>
                  <Col>
                    <Card
                      bg={bootstrapVariant.toLowerCase()}
                      key={bootstrapVariant}
                      text={bootstrapVariant.toLowerCase() === 'light' ? 'dark' : 'white'}
                      className="mb-2"
                    >
                      <Card.Body>
                        <Card.Title>No options available</Card.Title>
                        <Card.Text>
                          The selected area has no predicted incoming transportation. Please select another transport option or move to a different area on the map.
                        </Card.Text>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )
              }
              {
                !dataLoaded && <ProgressBar animated now={100} label='Loading...' />
              }
              {dataLoaded &&
                <><Row className='my-3'>
                  <Dropdown className='d-flex justify-content-end'>
                  <input type='text' value={stationFilter} onChange={(e)=>{ setStationFilter(e.target.value)}} placeholder='Filter Station' style={{width: "100%"}}></input>
                    <Dropdown.Toggle id="dropdown-sort" className='float-end' variant=''>
                      Sort By
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {
                        [...Object.keys(stopSortList)].map((value, index) => {
                          return <Dropdown.Item key={`stop-sort-${index}`} onClick={() => {
                            setStopListSortBy(value);
                            store(lastStopSort, value);
                          }} active={stopListSortBy == value}>{value}</Dropdown.Item>
                        })}
                    </Dropdown.Menu>
                  </Dropdown>
                  <br />
                </Row>
                  <ListGroup id='map-schedules'>
                    <ListGroup.Item key={-1}>
                      <Row>
                        <Col xs={6} className='d-flex justify-content-center' as={'h4'}><img src={MBTALogo} width={30} height={30} alt={MBTALogoAlt}></img>&nbsp;Station</Col>
                        <Col xs={6} className='d-flex justify-content-center border-start' as={'h4'}>Next</Col>
                      </Row>
                    </ListGroup.Item>
                    {getStopList([...stops.stops.values()], [...predictions.predictions.values()])}
                  </ListGroup>
                </>
              }
            </>
          }
          {
            currentPage == "Schedules" &&
            <Accordion>
              <input className='my-3' type='text' value={routeFilter} onChange={(e)=>{ setRouteFilter(e.target.value)}} placeholder='Filter Route' style={{width: "100%"}}></input>
              {
                (
                  [...routes.routes.values()].map((route, routeIndex) => {
                    const stopDirections = new Map<string, number>()
                    const routePredictions = predictions.predictions.filter((prediction) => {
                      if (prediction.route_id == route._id && prediction.direction_id == route.current_direction) {
                        stopDirections.set(prediction.stop_id, prediction.direction_id);
                      }

                      return prediction.route_id == route._id && (prediction.arrival_time > new Date() || prediction.departure_time > new Date());
                    }).map((stop) => {
                      let event = `"no time provided"`;
                      if (stop.departure_time.getTime() == 0 && stop.arrival_time.getTime() == 0) {
                        event = "status uknown";
                      }
                      else if (stop.arrival_time.getTime() > new Date()) {
                        event = `Arriving at ${stop.arrival_time.getHours().toString().padStart(2, "0")}:${stop.arrival_time.getMinutes().toString().padStart(2, "0")}`;

                      } else if (stop.departure_time.getTime() > new Date()) {
                        event = `Departing at ${stop.departure_time.getHours().toString().padStart(2, "0")}:${stop.departure_time.getMinutes().toString().padStart(2, "0")}`;
                      }
                      return { event: event, stop_id: stop.stop_id };
                    });

                    if (routePredictions.length == 0) {
                      return;
                    }
                    const routeName = `${transportMode == '3' && route?.short_name != "" ? `${route?.short_name} - ` : ""}${route?.long_name}` 
                    if(routeFilter != "" && routeName.toLowerCase().indexOf(routeFilter.toLowerCase()) < 0){
                      return;
                    }
                    return (
                      <Accordion.Item key={routeIndex} eventKey={routeIndex.toString()}>
                        <Accordion.Header><Placeholder xs={1} className="float-start" style={{
                          "backgroundColor": `#${routes.routes.get(route._id)?.color}`,
                          'width': "30px", "height": "30px", 'borderRadius': "20px", "opacity": "1"
                        }} align="end" />
                          <span className='m-3 w-100 text-truncate'>&nbsp;
                            {routeName}</span>
                        </Accordion.Header>
                        <Accordion.Body>
                          <Dropdown>
                            <Dropdown.Toggle className='w-100 text-truncate' variant={bootstrapVariant} id={`route-dropdown-${route._id}`}>
                              Direction: {route.directions[route.current_direction]}
                            </Dropdown.Toggle>
                            <Dropdown.Menu className='w-100'>
                              {
                                route.directions.map((direction: string, index: number) => {
                                  return (<Dropdown.Item key={index} eventKey={index} id={direction} onClick={(e) => {
                                    const currentRoutes = routes.routes;
                                    const target = e.target as HTMLElement;
                                    currentRoutes.get(route._id).current_direction = currentRoutes.get(route._id).directions.indexOf(target.id);
                                    setRoutesMutate(currentRoutes);
                                  }} >{direction}</Dropdown.Item>);
                                }
                                )
                              }
                            </Dropdown.Menu>
                          </Dropdown>
                          <br />
                          {
                            <ListGroup key={routeIndex} >
                              {
                                [...stopDirections].map((stop, stopIndex) => {

                                  return (
                                    <ListGroup.Item key={`list-${routeIndex}-${stopIndex}`}>
                                      <div className='d-flex flex-row justify-content-start align-items-center'>
                                        <img src={MBTALogo} width={15} height={15} alt={MBTALogoAlt}></img>&nbsp;
                                        <strong>{stops.stops.get(stop[0])?.name}</strong>
                                      </div>
                                      {/* {caret_right(undefined, undefined, 'float-end')} */}
                                      {
                                        routePredictions.filter((routePrediction) => {
                                          return routePrediction.stop_id == stop[0]
                                        }).map((routePrediction, index) => {
                                          if (index > 1) {
                                            return;
                                          }
                                          return <div key={`list-content-${routeIndex}-${stopIndex}-${index}`}>{routePrediction.event}</div>
                                        })
                                      }
                                    </ListGroup.Item>
                                  )
                                })
                              }
                            </ListGroup>
                          }

                        </Accordion.Body>
                      </Accordion.Item>)
                  })
                )
              }
            </Accordion>
          }
        </Container>
      </>
    </ThemeContext.Provider>
  )
}

export default App
